/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */

/**
 * Captions and on-screen text are written in this language.
 */
export type ContentLanguage = (typeof ContentLanguage)[keyof typeof ContentLanguage];

export const ContentLanguage = {
  EN_GB: 'EN_GB',
  EN_US: 'EN_US',
  FR: 'FR',
  ES: 'ES',
  DE: 'DE',
} as const;
